/**
 * The development branch (1.7), read live from the autobuild's own feed.
 *
 * Not mirrored and not baked into cameras.json on purpose: trunk filenames
 * carry the revision (`g7x-100b-1.7.0-6354-full.zip`), the bucket keeps only
 * the current build (an older revision is already gone -- 403), and the
 * autobuild rebuilds within about an hour of every source change. Any url we
 * stored would die; a url built from the feed at page load is the same one
 * the autobuild's own picker builds, from the same fields.
 *
 * The feed is CORS-open, ~38 KB gzipped and CloudFront-cached for 5 minutes,
 * so one lazy fetch per page load costs nothing worth a server-side cache.
 */

const BASE = 'https://build.chdk.photos';
const FEED = BASE + '/builds/trunk/meta/build_info.json';

let pending = null;

/** What the current trunk build is: { version, revision, utc }. */
export let trunkBuild = null;

/** camera id -> [{ id, status, full, small }], newest firmware first. */
function index(feed) {
  trunkBuild = feed.build || null;

  // The picker on build.chdk.photos resolves a download exactly this way:
  // base + files_path + '/' + fw.full.file.
  const dir = BASE + (feed.files_path || '/builds/trunk/bin');
  const file = (f) => (f ? { file: f.file, size: f.size, sha256: f.sha256, url: dir + '/' + f.file } : null);

  const out = {};

  (feed.files || []).forEach((family) =>
    (family.models || []).forEach((model) => {
      out[model.id] = (model.fw || [])
        .map((fw) => ({
          id: fw.id,
          status: (fw.status || '').toLowerCase(),
          full: file(fw.full),
          small: file(fw.small),
        }))
        .sort((a, b) => b.id.localeCompare(a.id));
    })
  );

  return out;
}

/**
 * Resolves to the camera-id map, or to {} when the autobuild is unreachable --
 * a missing development section is the correct degraded state, not an error.
 */
export function trunkBuilds() {
  if (!pending) {
    pending = fetch(FEED)
      .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
      .then(index)
      .catch(() => ({}));
  }

  return pending;
}

/**
 * The autobuild's own picker: branch / family / model / firmware. The escape
 * hatch when a rebuild has replaced the file this page linked.
 */
export function autobuildUrl(camera, fwId) {
  const path = ['trunk', camera.line, camera.id].concat(fwId ? [fwId] : []);

  return BASE + '/#build=' + path.join('/');
}
